import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizationPipe } from '@abp/ng.core';
import { Observable } from 'rxjs';
import { TabsModule } from 'primeng/tabs';
import { InboundNumbersListComponent } from '../inbound-numbers-list/inbound-numbers-list.component';
import { OutboundNumbersListComponent } from '../outbound-numbers-list/outbound-numbers-list.component';
import { PhoneNumberTestDialogComponent } from '../phone-number-test-dialog/phone-number-test-dialog.component';
import { InboundNumberService } from '../../services/inbound-number.service';
import { OutboundNumberService } from '../../services/outbound-number.service';
import { InboundNumberDto } from '../../models/inbound-number.dto';
import { OutboundNumberDto } from '../../models/outbound-number.dto';
import { PhoneNumberType } from '../../models/phone-number-type.enum';
import { PhoneNumberConnectivityResultDto } from '../../models/phone-number-connectivity-result.dto';

@Component({
  selector: 'app-phone-numbers-main',
  standalone: true,
  imports: [
    CommonModule,
    LocalizationPipe,
    TabsModule,
    InboundNumbersListComponent,
    OutboundNumbersListComponent,
    PhoneNumberTestDialogComponent,
  ],
  templateUrl: './phone-numbers-main.component.html',
  styleUrl: './phone-numbers-main.component.scss',
})
export class PhoneNumbersMainComponent {
  private readonly inboundNumberService = inject(InboundNumberService);
  private readonly outboundNumberService = inject(OutboundNumberService);

  readonly inboundTab = 'inbound';
  readonly outboundTab = 'outbound';
  activeTab = this.inboundTab;

  testDialogVisible = false;
  testPhoneNumber = '';
  testKind: PhoneNumberType = PhoneNumberType.Inbound;
  testRun$: Observable<PhoneNumberConnectivityResultDto> | null = null;
  testRunToken = 0;

  onInboundTest(row: InboundNumberDto): void {
    if (row.id == null) {
      return;
    }
    this.testPhoneNumber = row.phoneNumber;
    this.testKind = PhoneNumberType.Inbound;
    this.testRun$ = this.inboundNumberService.testConnectivity(row.id);
    this.openTestDialog();
  }

  onOutboundTest(row: OutboundNumberDto): void {
    if (row.id == null) {
      return;
    }
    this.testPhoneNumber = row.phoneNumber;
    this.testKind = PhoneNumberType.Outbound;
    this.testRun$ = this.outboundNumberService.testConnectivity(row.id);
    this.openTestDialog();
  }

  onTestVisibleChange(visible: boolean): void {
    this.testDialogVisible = visible;
    if (!visible) {
      this.testRun$ = null;
    }
  }

  private openTestDialog(): void {
    this.testDialogVisible = true;
    this.testRunToken++;
  }
}
